<template>
  <svg width="32px" height="32px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32">
    <defs>
      <path id="b" d="M7.41 1.41L6 0 0 6l6 6 1.41-1.41L2.83 6z" fill="#0DB4E6"/>
    </defs>
    <g fill-rule="evenodd">
      <use fill="#000" fill-rule="nonzero" xlink:href="#b" transform="translate(12 10)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'BackIcon',
};
</script>

<style scoped>

</style>
